<template>
  <div>
    <v-img
      alt="Vuetify Logo"
      class="shrink ma-0 pa-0"
      src="../assets/denah.jpeg"
      transition="scale-transition"
      width="auto"
    />

    <v-col class="px-4">
      <v-card class="mx-auto rounded-lg" elevation="16">
        <v-card-text class="pb-3"> Room Information </v-card-text>
        <v-card-text
          class="text-h6 pb-15 text-sm-h4 font-weight-bold black--text"
        >
          {{ getInfo.roomName }}
        </v-card-text>
      </v-card>
    </v-col>
    <v-col class="mb-16">
      <a
        href="https://zoom.us/j/5725597207?pwd=a3NYaEVoUU0wWHcxVUk1WG9oYjc4UT09" 
        target="_blank"
      >
        <v-card class="rounded-lg orange lighten-1">
          <v-card-text class="text-xs-caption  font-weight-bold  ma-0 pa-0">
            <v-list-item-group>
              <v-list-item>
                <v-list-item-icon>
                  <v-img
                    height="50"
                    width="50"
                    src="https://seeklogo.com/images/Z/zoom-icon-logo-C552F99BAC-seeklogo.com.png" 
                  ></v-img>
                </v-list-item-icon>
                <v-list-item-content class="text-link" > Zoom Link </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-card-text>
        </v-card>
      </a>
    </v-col>
  </div>
</template>

<script>
export default {
  computed: {
    getInfo() {
      return this.$store.getters.userInfo;
    },
  },
};
</script>
<style scoped>
a,.text-link,.text-link:active, .text-link:link{
  text-decoration: none !important;
  color: rgb(255, 255, 255);
  font-size: 1.5rem;
  text-transform: uppercase;
}
</style>